import { valueAccessor } from '@syncfusion/ej2-react-grids'
import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate, getListFromValues, getListItems } from 'Tyan/public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from 'Tyan/public/utility/formValues'
// import CostBearingDepartmentDiv from './CostBearingDepartmentDiv'
import { exportFile } from 'Tyan/public/index'

class AdvanceApply extends React.Component {
    state = {
        changedValues基本信息: {},
        id: this.props.match.params.id,
    }

    componentDidMount = () => {
        const { id } = this.state
        this.handlerInitValue(id)
    }

    componentWillUnmount = () => {
        this.unmount = true
    }

    handlerInitValue = (id) => {
        const { taskName } = this.props
        Tyan.doPostEvent({
            event: 'GetAdvanceOrder',
            data: { id, taskName },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas, })
                }
            }
        })
    }

    handlerAdvanceExport = () => {
        const { id } = this.state
        exportFile(null, null, "AdvanceExport?id=" + id)
    }

    handlerSave = (costBearingDepID = 0, name = '') => {
        const { readOnly } = this.props
        const { id, changedValues基本信息 } = this.state
        const 预支名称 = getFormValue(this, '基本信息', '预支名称')
        const 状态 = getFormValue(this, '基本信息', '状态')
        var item = ['预支人', /* '所属单位', */ '委外单位', '预支金额', '付款方式', '付款期限']
        for (var i = 0; i < item.length; i++) {
            if (item[i] == '委外单位')
                if (预支名称 == '其它') continue
            if (!getFormValue(this, '基本信息', item[i])) {
                Ext.toast(`${item[i]}必填`)
                return
            }
        }
        if (this.bChanged() && 状态 == '申请中')
            Tyan.doPostEvent({
                event: 'SaveAdvanceOrder',
                data: { id, changedValues基本信息 },
                onEnd: ({ errorMessage, id }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('保存成功')
                        this.handlerInitValue(id)
                    }
                }
            })
    }

    handlerClose = () => {
        const { } = this.props
        if (!this.bChanged()) {
            window.history.back()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => window.history.back())
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteAdvanceOrder',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        window.history.back()
                    }
                }
            }))
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    canSave = () => {
        const 预支名称 = getFormValue(this, '基本信息', '预支名称')
        return getFormValue(this, '基本信息', '预支人') &&
            getFormValue(this, '基本信息', '预支金额') &&
            getFormValue(this, '基本信息', '付款方式') &&
            getFormValue(this, '基本信息', '付款期限') &&
            getFormValue(this, '基本信息', '用途说明')
    }

    handleRelatedPersonChange = (v) => {
        const { optionsParas } = this.state
        const 预支类型 = getFormValue(this, '基本信息', '预支类型')
        changeItemsValue(this, '基本信息', ['预支部门'], [optionsParas[v].depName])
        if (预支类型 == '员工') {
            changeItemsValue(this, '基本信息', ['开户银行'], [optionsParas[v].bank])
            changeItemsValue(this, '基本信息', ['银行账号'], [optionsParas[v].bankAccount])
            changeItemsValue(this, '基本信息', ['供应商'], [v])
        }
    }
    handleCustomerNameChange = (v) => {
        Tyan.doPostEvent({
            event: 'GetBankMessage',
            data: { 单位名称: v },
            onEnd: ({ errorMessage, AccountOpeningBank, BankAccount }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    changeItemsValue(this, '基本信息', ['开户银行'], [AccountOpeningBank])
                    changeItemsValue(this, '基本信息', ['银行账号'], [BankAccount])
                }
            }
        })
    }

    handleAdvanceTypeChange = (v, id) => {
        const { optionsParas } = this.state
        Tyan.doPostEvent({
            event: 'GetCustomersData',
            data: { 预支类型: v, id: id },
            onEnd: ({ options }) => {
                if (options) {
                    this.setState({ optionsParas: { ...optionsParas, '供应商': options } })
                }
            }
        })
    }

    handleAdvanceAmountChange = (v) => {
        changeItemsValue(this, '基本信息', ['支付金额'], [v])
    }

    handleCurrencyNameChange = (v) => {
        const 申请时间 = getFormValue(this, '基本信息', '申请时间')
        Tyan.doPostEvent({
            event: 'GetExchangeRateByCurrency',
            data: { 币别: v, 申请时间 },
            onEnd: ({ errorMessage, ExchangeRate }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    changeItemsValue(this, '基本信息', ['汇率'], [ExchangeRate])
                }
            }
        })
    }

    handleNumberChange = (v) => {
        const 预支类型 = getFormValue(this, '基本信息', '预支类型')
        Tyan.doPostEvent({
            event: 'GetSupplierName',
            data: { 采购单号: v, 预支类型 },
            onEnd: ({ errorMessage, SupplierName, AccountOpeningBank, BankAccount }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    changeItemsValue(this, '基本信息', ['供应商', '开户银行', '银行账号'], [SupplierName, AccountOpeningBank, BankAccount])
                }
            }
        })
    }

    handleCustomerChange = (v) => {
        var person = ''
        var supplier = ''
        var customer = ''
        const 预支类型 = getFormValue(this, '基本信息', '预支类型')
        if (预支类型 == '员工')
            person = v
        else if (预支类型 == '供应商')
            supplier = v
        else if (预支类型 == '客户')
            customer = v
        if (预支类型 == '其他')
            Tyan.doPostEvent({
                event: 'GetOtherBankInfo',
                data: { customer: v },
                onEnd: ({ errorMessage, bankInfo }) => {
                    if (errorMessage)
                        Tyan.pubForm.showError(errorMessage)
                    else
                        changeItemsValue(this, '基本信息', ['开户银行', '银行账号'], [bankInfo.开户银行, bankInfo.银行账号])
                }
            })
        else
            Tyan.doPostEvent({
                event: 'GetBankInfo',
                data: { person, supplier, customer },
                onEnd: ({ errorMessage, bankInfo }) => {
                    if (errorMessage)
                        Tyan.pubForm.showError(errorMessage)
                    else
                        changeItemsValue(this, '基本信息', ['开户银行', '银行账号'], [bankInfo.开户银行, bankInfo.银行账号])
                }
            })
    }

    fieldset基本信息 = () => {
        const { readOnly } = this.props
        const 预支名称 = getFormValue(this, '基本信息', '预支名称')
        const 采购单号 = getFormValue(this, '基本信息', '采购单号')
        const 状态 = getFormValue(this, '基本信息', '状态')
        const 预支类型 = getFormValue(this, '基本信息', '预支类型')
        const 客户名称 = getFormValue(this, '基本信息', '客户名称')
        return [
            { _text: '预支单号', disabled: true },
            { _datetime: '申请时间', disabled: true, },
            { _text: '申请人', disabled: true },
            { _text: '申请部门', disabled: true },
            { _select: '预支人', required: true, onChange: (v) => this.handleRelatedPersonChange(v), },
            { _text: '预支部门', disabled: true },

            { _select: '币别', onChange: (v) => this.handleCurrencyNameChange(v), },
            { _float: '汇率', disabled: true },
            { _float: '预支金额', required: true, onChange: (v) => this.handleAdvanceAmountChange(v), },
            { _text: '用途说明', maxRows: 4, required: true, },

            { _radio: '预支名称', },
            { _select: '委外单位', minWidth: '90%', required: true, cdt: () => 预支名称 == '委外测试费用', editable: true, onChange: (v) => this.handleCustomerNameChange(v, this.props.id), },
            { _select: '付款方式', required: true },
            { _select: '付款期限', required: true },
            { _select: '预支类型', cdt: () => 预支名称 == '其它', onChange: (v) => this.handleAdvanceTypeChange(v, this.props.id), },
            { _select: `${预支类型 == '客户' ? '客户名称' : '供应商' && 预支类型 == '员工' ? '员工姓名' : '供应商' && 预支类型 == '其他' ? '名称' : '供应商'}`, name: '供应商', editable: true, forceSelection: false, cdt: () => 预支名称 == '其它', onChange: (v) => this.handleCustomerChange(v) },
            { _text: '开户银行', },
            { _text: '银行账号', },
            { _files: '附件' },
        ]
    }

    fieldset流转日志 = () => {
        return [
            { _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly } = this.props
        const { errorMessage, id, initValues基本信息, } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 提交时间 } = initValues基本信息
        const bSubmit = this.bChanged()
        return <Body data={this}
            controls={
                readOnly ? [
                    { _button: this.bChanged() && '取消' || '关闭', icon: '', handler: this.handlerClose },
                ] :
                    [
                        { _flow: 'AdvanceFlow', icon: '', disabled: this.bChanged() || !this.canSave(), cdt: () => id > 0, onFinish: () => window.history.back() },
                        { _button: '保存', icon: '', handler: () => this.handlerSave(0, ''), disabled: !(this.canSave() && this.bChanged()), cdt: () => 状态 == '申请中' },
                        { _button: '删除', icon: '', ui: 'action decline alt', cdt: () => id > 0 && 状态 == '申请中' && 提交时间 == nullDate, handler: this.handlerDelete, disabled: this.bChanged() },
                        { _button: this.bChanged() && '取消' || '关闭', icon: '', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '预支申请', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly || 状态 !== '申请中', docked: 'top', height: '68%', },
                    { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
                ]
            }
        />
    }
}

export default connect()(AdvanceApply)